import { I18nAndL10n } from '@application/i18n/i18n_and_l10n';
import { withTranslation } from '@application/i18n/with_translation';
import { Flex, InputRadio, TextLink } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { InformationGatheringSexAssignedAtBirth } from '@visiba/api-vcs-client-v2';
import { useState } from 'react';
import { SexExplanationDialog } from './sex-explanation-dialog.component';

export function SexAssignedAtBirthField() {
	const [showExplanation, setShowExplanation] = useState(false);

	return (
		<Flex gap={tokens.spacing.x1}>
			<InputRadio.Root
				label={withTranslation('View.CreateNewMessage.InformationGathering.SexAssignedAtBirth.Label')}
				variant='outlined'
				name='sexAssignedAtBirth'
				required
				options={{ required: I18nAndL10n.translate('Form.ValidationError.OnlyOneOption') }}
			>
				<InputRadio.Item
					label={withTranslation('View.CreateNewMessage.InformationGathering.SexAssignedAtBirth.Female')}
					value={InformationGatheringSexAssignedAtBirth.Female}
				/>
				<InputRadio.Item
					label={withTranslation('View.CreateNewMessage.InformationGathering.SexAssignedAtBirth.Male')}
					value={InformationGatheringSexAssignedAtBirth.Male}
				/>
				<InputRadio.Item
					label={withTranslation('View.CreateNewMessage.InformationGathering.SexAssignedAtBirth.PreferNotToSay')}
					value={InformationGatheringSexAssignedAtBirth.PreferNotToSay}
				/>
			</InputRadio.Root>
			<TextLink as='button' type='button' size='small' onClick={() => setShowExplanation(true)}>
				{withTranslation('View.CreateNewMessage.InformationGathering.SexAssignedAtBirth.WhyWeAsk')}
			</TextLink>
			<SexExplanationDialog isOpen={showExplanation} onClose={() => setShowExplanation(false)} />
		</Flex>
	);
}
